(function ($) {

  const initializeContentSliderBlock = function ($block) {
    $('.wp-block-cite-wordpress-theme-content-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      cssEase: 'ease',
      speed: 600,
      autoplay: false,
      autoplaySpeed: 5000,
      pauseOnHover: true,
    });
  }

  // Initialize each block on page load (front end).
  $(document).ready(function () {
    initializeContentSliderBlock();
  });


})(jQuery);

